import { isAfter } from 'date-fns';

import type { IEtazhiBlackFridayPromoOffersDataByPlatform } from 'shared/types/etazhiBlackFriday';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function getIsStartDatePassed(etazhiPromoOffersData: IEtazhiBlackFridayPromoOffersDataByPlatform | null) {
  const visibilityTimestamp = etazhiPromoOffersData?.startDate ?? null;

  if (!visibilityTimestamp) {
    return true;
  }

  const startDate = new Date(visibilityTimestamp);
  const now = new Date();

  const isStartDatePassed = isAfter(now, startDate);

  return isStartDatePassed;
}
